import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import instance from "../instance"; // Your Axios instance


// Fetch Projects
export const useFetchSurvey = (filters) => {
    const fetchSurvey = async () => {
      const { data } = await instance.get(`/api/survey-types?pageNumber=${filters?.pageNumber}&pageSize=${filters?.pageSize}&projectId=${filters?.projectId}`); // Your API endpoint
      return data;
    };
  
    const query = useQuery({
      queryKey: ['fetch surveys', filters],
      queryFn: fetchSurvey,
    });
  
    return query;
  };

// Add Project
export const useAddSurvey = () => {
    const queryClient = useQueryClient();
    const addProjectMutation = useMutation(async (newProject) => {
      const { data } = await instance.post('/api/survey-types', newProject); // Your API endpoint
      return data;
    }, {
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch survey']);
      },
    });
  
    return addProjectMutation;
  };